import Swal from 'sweetalert2';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import SurveyProcessingPoll from 'src/javascripts/components/surveys/SurveyProcessingPoll';

export default class Surveys {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');

    // Start processing status poll if updating
    SurveyProcessingPoll();

    // Change status
    $('.set-survey-status').on('click', function(e) {
      e.preventDefault();
      let surveySlug = $(this).attr('data-slug');
      let status = $(this).attr('data-status');
      let url = '/' + accountUrl + '/surveys/' + surveySlug;
      let params = {};
      params['survey'] = {};
      params['survey']['status'] = status;
      url = url + '?' + $.param(params);

      let text, title, confirmText;
      switch (status) {
        case 'draft':
          title = 'Move Survey to Drafts';
          text = 'Are you sure you want to move this survey back to drafts?';
          confirmText = 'Move to Drafts';
          break;
        case 'active':
          title = 'Activate Survey';
          text = 'Are you sure you want to activate this survey? This will appear in your list of active surveys.';
          confirmText = 'Activate Survey';
          break;
        case 'submitted':
          title = 'Mark Survey Submitted';
          text = 'Marking this survey as submitted indicates responses are ready for review. Continue?';
          confirmText = 'Mark Submitted';
          break;
        case 'approved':
          title = 'Approve Survey';
          text = 'Approving the survey closes the workflow and records the approval date. Do you want to proceed?';
          confirmText = 'Approve Survey';
          break;
        case 'inactive':
          title = 'Set Survey Inactive';
          text = 'Setting a survey inactive hides it from active lists without deleting it. Continue?';
          confirmText = 'Set Inactive';
          break;
        default:
          title = 'Update Survey Status';
          text = 'Are you sure you want to update this survey status?';
          confirmText = 'Update Status';
      }

      // Confirm and then continue with request
      return Swal.fire({
        title: title,
        text: text,
        animation: false,
        focusConfirm: false,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: confirmText,
        customClass: {
          cancelButton: 'btn btn-white border',
          confirmButton: 'btn btn-primary',
          popup: 'animated fadeIn faster'
        }
      }).then((result) => {
        if (result.value) {
          $.ajax({
            type: 'PATCH',
            url: url,
            dataType: 'application/json',
            complete(result) { 
              let url = window.location.pathname;
              Turbo.visit(url);
            },
          });
        }
      });    
    })

	}

}
